var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssigneeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80545 3.23077C7.80545 4.58477 6.67756 5.71154 5.24989 5.71154C3.82222 5.71154 2.69434 4.58477 2.69434 3.23077C2.69434 1.87677 3.82222 0.75 5.24989 0.75C6.67756 0.75 7.80545 1.87677 7.80545 3.23077Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.9999C9.5 9.96072 8.77082 8.30762 5.25 8.30762C1.72918 8.30762 1 9.96072 1 11.9999",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssigneeIcon);
export default __webpack_public_path__ + "static/media/assignee_icon.c7cc8289.svg";
export { ForwardRef as ReactComponent };